import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PRODUCTS } from '../config/apps';
import api from '../services/api';

// The "CLTS Products" view. Shows the static deployed products (e.g. Digital Signature,
// which opens in a new tab) plus any PM Center projects flagged category = "Product",
// fetched via the DevOps backend at /api/pm-projects?category=Product.
export default function Products() {
  const navigate = useNavigate();
  const [pmProducts, setPmProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/pm-projects', { params: { category: 'Product' } })
      .then(r => setPmProducts(r.data || []))
      .catch(() => setPmProducts([]))
      .finally(() => setLoading(false));
  }, []);

  const Card = ({ icon, color, name, description, badge, onClick }) => (
    <div
      onClick={onClick}
      style={{
        background: '#fff', borderRadius: 16, padding: 24, border: '1px solid #e5e7eb',
        cursor: onClick ? 'pointer' : 'default', transition: 'all 0.15s',
        display: 'flex', flexDirection: 'column', gap: 12, minHeight: 150,
      }}
      onMouseEnter={e => { if (onClick) { e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.12)'; e.currentTarget.style.transform = 'translateY(-2px)'; } }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'none'; }}
    >
      <div style={{ width: 52, height: 52, borderRadius: 12, background: color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26 }}>{icon}</div>
      <div>
        <div style={{ fontSize: 17, fontWeight: 700, color: '#0f172a' }}>{name} {badge && <span style={{ fontSize: 11, color: '#94a3b8', fontWeight: 500 }}>{badge}</span>}</div>
        <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>{description}</div>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', padding: '40px 24px' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <button onClick={() => navigate('/')} style={{
          background: 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.15)',
          borderRadius: 8, padding: '8px 16px', fontSize: 13, cursor: 'pointer', marginBottom: 24,
        }}>← Back to apps</button>

        <h1 style={{ color: '#fff', fontSize: 28, fontWeight: 700 }}>📦 CLTS Products</h1>
        <p style={{ color: '#94a3b8', marginBottom: 28 }}>Cloud Leaders products & solutions</p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 20 }}>
          {/* Static deployed products */}
          {PRODUCTS.map(p => (
            <Card key={p.key} icon={p.icon} color={p.color} name={p.name} description={p.description}
              badge={p.external ? '↗' : ''}
              onClick={() => p.external ? window.open(p.url, '_blank', 'noopener,noreferrer') : (window.location.href = p.url)} />
          ))}

          {/* Products maintained as PM projects (category = Product). Clickable when a Live URL is set. */}
          {pmProducts.map(p => (
            <Card key={`pm-${p.id}`} icon="🧩" color="#7c3aed"
              name={p.projectName} description={p.description || p.projectCode || 'PM product'}
              badge={p.liveUrl ? '↗' : ''}
              onClick={p.liveUrl ? () => window.open(p.liveUrl, '_blank', 'noopener,noreferrer') : undefined} />
          ))}
        </div>

        {!loading && PRODUCTS.length === 0 && pmProducts.length === 0 && (
          <div style={{ color: '#94a3b8', textAlign: 'center', marginTop: 40 }}>No products yet.</div>
        )}
      </div>
    </div>
  );
}
